export enum EventTypes {
  ICON_LOADED = 'ICON_LOADED',
}

export interface IIconLoadedActionPayload {
  icon: string;
}

/**
 * The icon reducer
 */

export interface IIconReducer {
  [key: string]: boolean;
}

export type IReducerPayload = IIconLoadedActionPayload;
